import styled from 'styled-components';

export const StyledDiv = styled.div`
  padding-bottom: 16px;
  padding-top: 16px;
  border-bottom: 1px solid var(--beam-color-neutral-n300);

  width: 100%;
  overflow: auto;
  .Shortcuts_list {
    display: flex;
    align-items: center;
    justify-content: left;
    column-gap: 8px;
  }
  .Shortcuts_list_item {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    align-items: center;

    padding: 15px 11px;
    background-color: var(--beam-color-neutral-n100);
    color: var(--beam-color-neutral-n600);
    border: 1px solid var(--beam-color-neutral-n400);
    border-radius: 6px;
  }
  .Shortcuts_list_item_label {
    min-width: 70px;
    text-align: center;
  }
`;
